import React, { useMemo, useCallback, useState } from "react"
import { FC } from "react"
import { Container } from "react-bootstrap"
import "prismjs/themes/prism.css"
import { useDropzone } from "react-dropzone"
import { getStorage, ref, uploadBytes } from "firebase/storage"
import { store } from "../../store"

const storage = getStorage()

const baseStyle = {
    flex: 1,
    display: "flex",
    alignItems: "center",
    paddingWidth: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "solid",
    backgroundColor: "rgba(0,0,0,0.3)",
    color: "#bdbdbd",
    transition: "border .24s ease-in-out",
    height: "50vh",
}

const focusedStyle = {
    borderColor: "#f8c414",
}

const acceptStyle = {
    borderColor: "#f8c414",
}

const rejectStyle = {
    borderColor: "#f84e2a",
}

const getUserUID = () => {
    return store.getState().user.uid
}

const uploadFile = (file: File) => {
    const storageRef = ref(storage, `vocab-store/${getUserUID()}-vocab.db`)
    uploadBytes(storageRef, file).then((snapshot: any) => {
        console.log("Uploaded a blob or file!")
    })
}

const VocabUpload: FC = () => {
    const [files, setFiles] = useState([])
    const onDrop = useCallback(
        (files: any) => {
            setFiles(files)
            uploadFile(files[0])
            console.log(files)
        },
        [setFiles]
    )

    const {
        getRootProps,
        getInputProps,
        isFocused,
        isDragAccept,
        isDragReject,
    } = useDropzone({ accept: { "application/octet-stream": [".db"] }, onDrop })

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [isFocused, isDragAccept, isDragReject]
    )

    return (
        <section className="container-fluid">
            <div {...getRootProps({ className: "dropzone", style })}>
                <input {...getInputProps()} />
                <Container>
                    <span className="text-center dropzone-text">
                        Waiting for your{" "}
                        <code className="language-html">vocab.db</code> file...
                    </span>
                </Container>
            </div>
        </section>
    )
}

export default VocabUpload
